import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MapDutyComponent } from 'src/app/modules/settings/duties/map-duty/map-duty.component';
import { DutiesService } from 'src/app/modules/settings/duties/services/duties.service';
import { colorPalette, iconList } from '../../svg-icons/iconList';

@Component({
  selector: 'app-duty-list',
  templateUrl: './duty-list.component.html',
  styleUrl: './duty-list.component.scss',
})
export class DutyListComponent implements OnInit, AfterViewInit {
  @Input() planMonthName: string;
  @Input() planMonth: number;
  @Input() planYear: any;
  @Input() planDeptId: string;
  @Input() planReq: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dutyIconList = iconList;
  colorPalette = colorPalette;
  locationId =
    typeof window !== 'undefined' && window.sessionStorage
      ? sessionStorage.getItem('userLocationId')
      : null;
  dataSource: any = [];
  displayedColumns: string[] = [
    'icon',
    'name',
    'description',
    'dutyDuration',
    'breakDuration',
    'active',
  ];
  columnsToDisplayWithExpand = [...this.displayedColumns, 'more'];
  displayedExpandColumns: string[] = [
    'memberType',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];
  page: number = 0;
  totalRecords: number = 0;
  pageSize: number = 5;
  getAllDutyParam: any = {
    page: this.page,
    size: this.pageSize,
    locationId: this.locationId,
    picketDuty: false
  };
  showData: boolean = false;
  fetchApiData: any = [];
  planningSheetSaved: boolean = false;
  planningSheetPublished: boolean = false;
  planningActive: boolean = false;
  listDataLength: any;
  toggleId: any;

  constructor(public dutiesService: DutiesService, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadTableDataFromApi();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  loadTableDataFromApi(pageIndex?: number, pageSize?: number) {
    if (this.planReq) {
      this.getAllDutyParam = {
        ...this.getAllDutyParam,
        month: this.planMonth,
        year: this.planYear,
        departmentIds: this.planDeptId,
      };
    }
    this.getAllDutyParam.page = pageIndex;
    this.getAllDutyParam.size = pageSize;
    this.dutiesService
      .fetchAllDuties(this.getAllDutyParam)
      .subscribe((data) => {
        if (data.status === 200) {
          this.showData = true;
          this.prepareTableData(data);
        } else {
          this.showData = false;
        }
      });
  }

  prepareTableData(data: any, param?: any) {
    this.fetchApiData = data.body.content;
    // if (this.fetchApiData.length > 0)
    //   this.dutyDepartmentIdList = this.fetchApiData.map(
    //     (item: any) => item.dutyDepartmentId
    //   );
    this.planningSheetPublished = this.fetchApiData[0]?.planningSheetPublished;
    this.planningSheetSaved = this.fetchApiData[0]?.planningSheetSaved;
    this.planningActive = this.fetchApiData[0]?.activateForPlanning;
    this.listDataLength = this.fetchApiData.length;
    const today = new Date(); // Get the current date
    // Set today to the first day of the current month
    today.setDate(1);
    // Set time components of today to zero for comparison (only date matters)
    today.setHours(0, 0, 0, 0);
    // Compare currentMonth with today
    // this.isCurrentMonthOrLater = this.currentMonth >= today;

    // if (this.listDataLength === 0 && this.isSearch) {
    //   this.searchResult = false;
    // } else {
    //   this.searchResult = true;
    //   this.isSearch = false;
    //   this.searchActive = false;
    // }
    this.showData = true;
    this.dataSource = [];
    // this.formatedApiData = [];
    this.dataSource = new MatTableDataSource(this.fetchApiData);
    this.totalRecords = data.body.totalElements;
  }
  onPaginateChange(event: PageEvent) {
    this.loadTableDataFromApi(event.pageIndex, event.pageSize);
  }

  onToggleChange(event: any, id: any) {
    this.toggleId = id;
    const month = this.planMonth;
    const year = this.planYear;
    let availabilityFormData: any = { active: event, month: month, year: year };
    this.dutiesService
      .updateDutyStatus(this.toggleId, availabilityFormData)
      .subscribe((data) => {
        if (data.status === 204) {
          this.loadTableDataFromApi(0, this.pageSize);
        }
      });
  }

  handleCellClick(event: any, column: string): void {
    if (column === 'active') {
      event.stopPropagation();
    } else {
      // Handle other cell click actions
    }
  }

  editDuty(data: any) {
    const month = this.planMonthName; // October
    const year = this.planReq; // 2024
    let dialogData = {
      button: 'duties.map_duty_dialog.action.save_btn',
      cancelBtn: 'duties.map_duty_dialog.action.cancel_btn',
      title: 'duties.map_duty_dialog.title.edit_title',
      editDutyId: data.dutyDepartmentId,
      editId: data.dutyId,
      selectedMonthInt: this.planMonth,
      selectedMonth: this.planMonth,
      month: month,
      year: year,
      buttonName: 'Save',
      refreshDuties: () => this.loadTableDataFromApi(0, this.pageSize),
      globalEdit:true
    };
    const mapDialogRef = this.dialog.open(MapDutyComponent, {
      width: '920px',
      height: '583px',
      disableClose: true,
      data: dialogData,
    });
    mapDialogRef.afterClosed().subscribe((result) => {
      // Handle form data returned from dialog
      if (result === 'success' || result === 'update') {
        //success
        this.loadTableDataFromApi(0, this.pageSize);
      } else {
        console.log('Dialog closed without submitting.');
      }
    });
  }
}
